<div class="flex flex-col flex-1-0-100">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Check Out</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="add-task-diaolog"
              analyticsAction="close-btn">close
      </button>
    </mat-dialog-actions>

  </div>

  <mat-dialog-content class="flex flex-col justify-start items-start">
    <input type="text" ng-model="fileOrFolderName">
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">

  </mat-dialog-actions>
</div>
